import { classNames } from "primereact/utils";

import styles from "./page-header.module.scss";
import type { PageHeaderViewProps } from "./types-page-header";

export function PageHeaderView({
  printHide,
  variant,
  testId,
  className,
  style,
  rest,
  children,
}: PageHeaderViewProps) {
  return (
    <header
      className={classNames(styles.root, className)}
      style={style}
      data-variant={variant}
      data-print-hide={printHide || undefined}
      data-testid={testId}
      {...rest}
    >
      {children}
    </header>
  );
}
